import { Component } from '@angular/core';
import { SharedModule } from "../../shared/shared.module";
import { Router } from '@angular/router';

@Component({
  selector: 'app-auth-message',
  standalone: false,
  templateUrl: './auth-message.component.html',
  styleUrl: './auth-message.component.scss',
})
export class AuthMessageComponent {

  constructor(
    private readonly router : Router
  ){}

  navigateTo(route: string[]) {
    this.router.navigate(route);
  }


}
